import React from 'react'
import { Link } from 'react-router-dom'
import DoubleArrow from '../icons/DoubleArrow'
import { router_config, RouterMenuProps } from '../../../configs/route.config'

interface NavigatorProps {
  slug: string
  title: string
  middle_title?: string
}

const getBreadcrumbTrail = (slug: string): RouterMenuProps[] => {
  const item = Object.values(router_config).find((route) => route.key === slug)
  if (!item) return []

  const trail: RouterMenuProps[] = []
  let current: RouterMenuProps | undefined = item

  while (current) {
    trail.unshift(current)
    if (current.parent_id === null) break
    current = Object.values(router_config).find(
      (r) => r.id === current?.parent_id
    )
  }

  return trail
}

const Navigator: React.FC<NavigatorProps> = ({ slug, title, middle_title }) => {
  const trail = getBreadcrumbTrail(slug)

  return (
    <nav className="text-md text-gray-600 my-6" aria-label="Breadcrumb">
      <ol className="flex items-center flex-wrap space-x-2">
        <li>
          <Link
            to="/home"
            className="hover:underline text-gray-600 font-medium"
          >
            Home
          </Link>
        </li>

        {trail.map((item) => (
          <React.Fragment key={item.key}>
            <li>
              <DoubleArrow className="w-4 h-4 text-gray-400" />
            </li>
            <li>
              <Link
                to={item.path || '#'}
                className="hover:underline text-gray-600 font-medium"
              >
                {item.label}
              </Link>
            </li>
          </React.Fragment>
        ))}

        {middle_title && (
          <>
            <li>
              <DoubleArrow className="w-4 h-4 text-gray-400" />
            </li>
            <li>
              <span className="text-gray-600 font-medium">{middle_title}</span>
            </li>
          </>
        )}

        <li>
          <DoubleArrow className="w-4 h-4 text-gray-400" />
        </li>
        <li>
          <span className="text-PrimaryOrange font-semibold">{title}</span>
        </li>
      </ol>
    </nav>
  )
}

export default Navigator
